<div class="background-image shadow">
  @if (stream.background) {
    <figure>
      <mb-media class="absolute-centered" [media]="stream.background" [playsInline]="true"></mb-media>
    </figure>
  }
</div>

@if (isArchived) {
  <!-- class lives on a wrapper: Angular hydration re-applies static classes on SSR'd wb-* hosts and wipes Stencil's `hydrated` -->
  <div class="archived-tag">
    <wb-tag variant="tertiary" theme="light">{{ 'ARCHIVED_CONTENT' | translate }}</wb-tag>
  </div>
}

<div class="stream-card-content">
  <div class="stream-card-hash-wrapper copy-s">{{ stream.titleHash }}</div>
  <div class="stream-card-content-inner">
    @if (stream.status === videoStatus.LIVE) {
      <span class="stream-indicator-text">
        {{ stream.liveStatusIndicatorText }}
        <mb-live-indicator></mb-live-indicator>
      </span>
    }

    @if (stream.title) {
      <h2 class="stream-card-title" [innerHtml]="stream.title"></h2>
    }

    @if (stream.countdownDate && !countdownFinished && !startDateReached) {
      <mb-countdown
        [countdownTo]="stream.countdownDate"
        [countdownLabel]="stream.countdownLabel"
        [countdownType]="isMobile ? countdownTypes.FLAT : countdownType"
        (finished)="setCountdownDateReached()"
      ></mb-countdown>
    }

    @if (stream.status === videoStatus.STOPPED && stream.showLoadingAnimation) {
      <div class="buffer-container">
        <mb-buffering class="light"></mb-buffering>
      </div>
    }

    @if (stream.status === videoStatus.LIVE || stream.status === videoStatus.VOD) {
      <div class="stream-card-btn-wrapper">
        <button class="btn" [routerLink]="[]" [queryParams]="{ video: stream.id }">
          <span class="mb-icon mb-icon-rewatch"></span>
          <span>{{ stream.playButtonText || ('PLAY_NOW' | translate) }}</span>
        </button>
      </div>
    }

    @if (stream.subtitle) {
      <div class="stream-card-subtitle copy-l" [innerHtml]="stream.subtitle"></div>
    }
  </div>
  <div class="fuel-labels-wrapper copy-s">
    @if (stream.fuelLabel) {
      <span class="fuel-label" [innerHTML]="stream.fuelLabel"></span>
    }
  </div>
</div>
